export class Settings {
  apiUrl: string;
  country: string;
  companySubdomain: string;
}
